import React, { useState } from 'react';
import { Modal, Button, Alert, Icon } from '../../components';
import { scopeDescriptions, isHttpUrl } from './utils';
import './styles.scss';

export function AppIdentity({ application, showVerification = true }) {
  const [failedLogo, setFailedLogo] = useState(null);
  const logo = application?.logo_url;
  return <div className="oauth-identity">
    {logo && isHttpUrl(logo) && failedLogo !== logo
      ? <img src={logo} alt="" referrerPolicy="no-referrer" onError={() => setFailedLogo(logo)} />
      : <span className="oauth-logo-placeholder" aria-hidden="true"><Icon id="icon-monitor" size="24" /></span>}
    <div className="oauth-identity-text"><h3>{application?.name || 'Aplicativo não disponível'}</h3>
      {application && showVerification && <span className={`oauth-verification ${application.is_verified ? 'is-verified' : ''}`}><Icon id={application.is_verified ? 'icon-verified_user' : 'icon-info'} size="14" />{application.is_verified ? 'Verificado pela Assinafy' : 'Não verificado'}</span>}
    </div>
  </div>;
}

export function ScopeList({ scopes = [] }) {
  return <div className="oauth-permissions">
    <ul className="oauth-scopes">{scopes.filter(scope => scope !== 'offline_access').map(scope => <li key={scope}><Icon id="icon-check" size="16" /><span>{scopeDescriptions[scope] || 'Permissão não reconhecida. Reinicie a conexão após atualizar a página.'}</span></li>)}</ul>
    {scopes.includes('offline_access') && <div className="oauth-offline-notice"><Icon id="icon-schedule" size="20" /><div><strong>Acesso offline</strong><span>{scopeDescriptions.offline_access}.</span></div></div>}
  </div>;
}

export function ConfirmAction({ title, children, busy, error, onCancel, onConfirm, confirmLabel }) {
  return <Modal className="oauth-modal" show centered backdrop="static" keyboard={!busy} onHide={onCancel} aria-labelledby="oauth-confirm-title">
    <Modal.Header>
      <Button variant="icon" className="btn-close" aria-label="Fechar" disabled={busy} onClick={onCancel}><Icon id="icon-close" size="24" /></Button>
      <Modal.Title as="h2" className="h2" id="oauth-confirm-title">{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body><div className="oauth-confirm-description">{children}</div>{error && <Alert variant="danger" className="mt-3">{error}</Alert>}</Modal.Body>
    <Modal.Footer><Button variant="info" disabled={busy} onClick={onCancel}>Cancelar</Button><Button variant="danger" loading={busy} loadingText="Aguarde..." onClick={onConfirm}>{confirmLabel}</Button></Modal.Footer>
  </Modal>;
}

export function CopyValue({ label, value, secret = false }) {
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState('');
  const copy = async () => {
    try { await navigator.clipboard.writeText(value); setCopied(true); setError(''); }
    catch { setError('Selecione e copie o valor abaixo.'); }
  };
  return <div className="oauth-credential">
    <span className="oauth-field-caption">{label}</span>
    <div className="oauth-credential-value"><code data-private={secret ? 'true' : undefined}>{value}</code><Button variant="action" aria-label={secret ? 'Copiar segredo' : `Copiar ${label}`} onClick={copy}><Icon id={copied ? 'icon-check' : 'icon-copy'} size="18" /></Button></div>
    <span className="oauth-copy-status" role="status">{error || (copied ? 'Copiado para a área de transferência.' : '')}</span>
  </div>;
}
